import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { Academias } from '@/features/plataforma/componentes/Academias';
import { rotaDaPlataforma } from '@/features/permissoes/guardas';

const busca = z.object({
  nome: z.string().optional().catch(undefined),
  cursor: z.string().optional().catch(undefined),
});

/** Academias da plataforma (spec 014, CA-01 a CA-03). */
export const Route = createFileRoute('/_autenticado/plataforma/empresas')({
  ...rotaDaPlataforma('Academias'),
  validateSearch: busca,
  component: Pagina,
});

function Pagina() {
  const valores = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <Academias
      busca={valores}
      aoMudarBusca={(novos) => {
        void navigate({ search: novos, replace: true });
      }}
    />
  );
}
